import React, { createContext, type ReactNode, useContext, useMemo } from 'react';

export type AudioPlayerStreamingContextType = {
	fetchAudio: () => Promise<void>;
};

export const AudioPlayerStreamingContext = createContext<AudioPlayerStreamingContextType>({
	fetchAudio: async () => {},
});

export const AudioPlayerStreamingProvider = ({
	fetchAudio,
	children,
}: {
	fetchAudio: () => Promise<void>;
	children: ReactNode;
}) => {
	const value = useMemo(() => ({ fetchAudio }), [fetchAudio]);

	return (
		<AudioPlayerStreamingContext.Provider value={value}>
			{children}
		</AudioPlayerStreamingContext.Provider>
	);
};

export const useAudioPlayerStreamingContext = () => {
	return useContext(AudioPlayerStreamingContext);
};
